module.exports = __webpack_public_path__ + "assets/img/tx238_4.40f7a019.jpg";